export default __webpack_public_path__ + "static/media/menu-icon.8b6f7e80.svg";